import { useInstance } from 'intact-react';
import { useState } from '../../hooks/useState';
export function useFocusDate() {
  var instance = useInstance();
  var focusDate = useState(null);
  function reset() {
    focusDate.set(null);
  }
  instance.on('hide', reset);
  return {
    focusDate: focusDate,
    reset: reset
  };
}